module.exports = __webpack_public_path__ + "img/avada-food-logo-2x.a6dd4933.png";